import React from 'react';
import { Button } from '@/components/ui/button';
import { Layers } from 'lucide-react';

export type BlockType = 'instruction';

interface BlockTypeTogglesProps {
  activeBlocks: BlockType[];
  onToggleBlock: (type: BlockType) => void;
  isMultiInstruction?: boolean;
  onConvertMultiInstruction?: () => void;
  className?: string;
}

export function BlockTypeToggles({ 
  activeBlocks, 
  onToggleBlock, 
  isMultiInstruction = false,
  onConvertMultiInstruction,
  className 
}: BlockTypeTogglesProps) {
  const isActive = (type: BlockType) => activeBlocks.includes(type);
  const hasInstruction = isActive('instruction');
  
  return (
    <div className={`flex gap-2 mb-4 justify-end ${className}`}>
      {hasInstruction && onConvertMultiInstruction && (
        <Button
          variant={isMultiInstruction ? 'default' : 'outline'}
          size="sm"
          onClick={onConvertMultiInstruction}
          className="flex items-center gap-2"
        >
          <Layers className="h-4 w-4" />
          {isMultiInstruction ? 'Convertir en simple' : 'Convertir en multi'}
        </Button>
      )}
    </div>
  );
}

export function BlockTypeSelector({ activeType, onTypeChange, className }: { activeType: BlockType; onTypeChange: (type: BlockType) => void; className?: string; }) {
  return (
    <BlockTypeToggles
      activeBlocks={[activeType]}
      onToggleBlock={onTypeChange}
      className={className}
    />
  );
}


